import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import io from 'socket.io-client';

// 使用ElementUI
Vue.use(ElementUI, { size: 'medium' });

// 配置axios
axios.defaults.baseURL =
  process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3000/api';
axios.defaults.timeout = 10000;
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // token过期或无效
      store.dispatch('user/logout');
      router.replace('/login').catch(() => {});
      ElementUI.Message.error('登录已过期，请重新登录');
    } else if (
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      // 显示后端返回的错误信息
      ElementUI.Message.error(error.response.data.message);
    } else {
      // 其他错误
      ElementUI.Message.error('请求失败，请稍后重试');
    }
    return Promise.reject(error);
  }
);

// 将axios挂载到Vue原型上
Vue.prototype.$http = axios;

// 配置WebSocket
const socket = io(
  process.env.NODE_ENV === 'production' ? '/' : 'http://localhost:3000',
  {
    autoConnect: false,
  }
);

// 将socket挂载到Vue原型上
Vue.prototype.$socket = socket;

// 连接WebSocket
socket.on('connect', () => {
  console.log('WebSocket连接成功');
});

// 监听新的寻盘信息
socket.on('new_inquiry', (data) => {
  store.dispatch('updateNotification', { type: 'inquiry', count: data.count });
});

// 监听新的测样申请
socket.on('new_sample', (data) => {
  store.dispatch('updateNotification', { type: 'sample', count: data.count });
});

// 监听新的访客记录
socket.on('new_visitor', (data) => {
  store.dispatch('updateNotification', { type: 'visitor', count: data.count });
});

// 错误处理
socket.on('error', (error) => {
  console.error('WebSocket错误:', error);
});

// 断开连接处理
socket.on('disconnect', (reason) => {
  console.log('WebSocket断开连接:', reason);
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

// 登录成功后连接WebSocket
if (localStorage.getItem('token')) {
  socket.connect();
}
